import { GET_USER_DETAILS, GET_USER_TOKEN, IS_AUTH_USER, SET_USER_DETAILS } from "@/store/storeconstants";

export default{
 [GET_USER_DETAILS]:(state)=>{
  return state.userDetails;
 },

 [GET_USER_TOKEN]:(state)=>{
  return state.token;
 },

 [IS_AUTH_USER]:(state)=>{
  return !!state.token;
 }
};